module.exports = __webpack_public_path__ + "static/media/Doctors Portal.61b67365.png";